import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { usePageTitle } from '~/modules/common/title';
import { useIsBreakpointDown } from '~/modules/common/hooks';
import { RESOURCE_MANAGEMENT_DASHBOARD_TAB_ENUM } from '../common/enums/resourceManagementDashboardTabs';
import ResourcingOverview from '../ResourcingOverview';
import ResourceManagementDashboardTabs from './components/ResourceManagementDashboardTabs';
import ResourceManagementDashboardInsights from './components/ResourceManagementDashboardOverview/ResourceManagementDashboardInsights';
import TargetUtilizationSettingsDialog from './components/TargetUtilizationSettingsDialog';

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexWrap: 'nowrap',
    width: '100%',
    padding: 0,
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column'
    }
  }
}));

export const ResourceManagementDashboard = ({
  currentPage,
  setCurrentPage,
  selectedDashboardTab,
  setSelectedDashboardTab,
  targetUtilizationDialogOpen,
  onCloseTargetUtilizationDialog
}) => {
  const classes = useStyles();
  const isMDView = useIsBreakpointDown('md');

  usePageTitle([
    { messageId: 'routes.resourceManagement' },
    {
      messageId: `resourceManagementOverviewTabs.${selectedDashboardTab.toLowerCase()}`
    }
  ]);

  return (
    <Grid container className={classes.container}>
      <Grid item xs={isMDView ? 12 : 'auto'}>
        <ResourceManagementDashboardTabs
          selectedDashboardTab={selectedDashboardTab}
          setSelectedDashboardTab={setSelectedDashboardTab}
          orientation={isMDView ? 'horizontal' : 'vertical'}
        />
      </Grid>
      <Grid item xs>
        {selectedDashboardTab ===
          RESOURCE_MANAGEMENT_DASHBOARD_TAB_ENUM.INSIGHTS && (
          <ResourceManagementDashboardInsights />
        )}
        {selectedDashboardTab ===
          RESOURCE_MANAGEMENT_DASHBOARD_TAB_ENUM.ALLOCATION && (
          <ResourcingOverview
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
          />
        )}
      </Grid>
      {targetUtilizationDialogOpen && (
        <TargetUtilizationSettingsDialog
          open={targetUtilizationDialogOpen}
          onClose={onCloseTargetUtilizationDialog}
        />
      )}
    </Grid>
  );
};

ResourceManagementDashboard.propTypes = {
  currentPage: PropTypes.number.isRequired,
  setCurrentPage: PropTypes.func.isRequired,
  selectedDashboardTab: PropTypes.string.isRequired,
  setSelectedDashboardTab: PropTypes.func.isRequired,
  targetUtilizationDialogOpen: PropTypes.bool,
  onCloseTargetUtilizationDialog: PropTypes.func
};
export default ResourceManagementDashboard;
